// ============================================
// FE ルーティング path 定数
// 要件書 §3.2 キャンペーン申込フロー関連を const 化
// ============================================
//
// - `*_PATTERN`: react-router-dom の `<Route path>` 定義用 (`:hash`, `:token` 含む)
// - `build*Url`: navigate / Link `to` 用の動的 URL builder
//
// API リクエスト URL (BE エンドポイント) は本ファイル対象外。

// ─── キャンペーン申込フロー (Route 定義パターン) ─────
// Rev.20 S46: ROUTE_SIGN_UP_REGISTER_TYPE_SELECT_PATTERN は廃止 (概要書面交付方法選択フローを通常 QR と共有)
export const ROUTE_CAMPAIGN_SIGN_UP_PATTERN = '/campaignSignUp/:hash' as const
export const ROUTE_CAMPAIGN_SIGN_UP_CONFIRM_PATTERN = '/campaignSignUpConfirm/:hash' as const
export const ROUTE_CAMPAIGN_SIGN_UP_VERIFY_PATTERN = '/campaignSignUp/verify/:token' as const

// ─── キャンペーン申込フロー (静的 path) ─────
export const ROUTE_CAMPAIGN_SIGN_UP_COMPLETE = '/campaignSignUpComplete' as const
export const ROUTE_CAMPAIGN_QR_EXPIRED = '/campaignQrExpired' as const
export const ROUTE_REGISTRATION_EXPIRED = '/registrationExpired' as const
// QR inspect が campaignQrInvalid (hash 復号不可 = URL 破損・転記ミス) を返した invite QR の着地先
export const ROUTE_INVITE_URL_INVALID = '/inviteUrlInvalid' as const

// ─── キャンペーン申込フロー (Route 定義パターン・追加) ─────
export const ROUTE_CAMPAIGN_DONE_PATTERN = '/campaign/done/:token' as const

// ─── QR ランディング → 通常 QR ハンドオフ (Phase A-2 案A) ─────
// SignUpIntroduction.tsx (QR-inspect 入口) で isCampaign=false と判定された
// 通常 QR ユーザーを SummarySelect.tsx (概要書面選択画面) に渡すためのルート。
// QR URL 自体 (`/summarySelect/:type/:hash`) は変えず、ルーティング層で責務分離する。
export const ROUTE_QR_INSPECT_ENTRY_PATTERN = '/summarySelect/:type/:hash' as const
export const ROUTE_SUMMARY_SELECT_FLOW_PATTERN = '/summarySelectFlow/:type/:hash' as const

// ─── 共通 path ─────
export const ROUTE_LOGIN = '/login' as const

// ─── 動的 URL builder (navigate / Link 用) ─────
// Rev.20 S46: buildSignUpRegisterTypeSelectUrl は廃止
export const buildCampaignSignUpUrl = (hash: string): string => `/campaignSignUp/${hash}`
export const buildCampaignSignUpConfirmUrl = (hash: string): string => `/campaignSignUpConfirm/${hash}`
export const buildCampaignDoneUrl = (token: string): string => `/campaign/done/${token}`
export const buildSummarySelectFlowUrl = (type: string, hash: string): string => `/summarySelectFlow/${type}/${hash}`
